import { apiRequest } from "./client";

export async function createDonationSession(payload, authToken = "") {
  return apiRequest(
    "/donations/checkout-session",
    "POST",
    payload,
    authToken
  );
}

export async function fetchDonationSummary() {
  return apiRequest("/donations/summary");
}

export async function fetchDonations() {
  return apiRequest("/donations");
}

export async function fetchDonationRequests() {
  return apiRequest("/donations/requests");
}

export async function startEmailVerification(payload) {
  return apiRequest("/donations/verify-email/start", "POST", payload);
}

export async function confirmEmailVerification(payload) {
  return apiRequest("/donations/verify-email/confirm", "POST", payload);
}
